module.exports = __webpack_public_path__ + "static/media/appliedmlcert.7ea8a298.jpg";